import { useDisclosure, Flex, HStack } from '@chakra-ui/react'
import { Box, Button, Stack } from '@chakra-ui/react'
import React, { useEffect, useRef, useState } from 'react'
import { useLocation, useNavigate } from 'react-router'
import { useTranslation } from 'react-i18next'
import { TransactionsTable } from 'features/project-details/transactions/transactions-table'
import { usePCProject } from 'api/pc-projects'
import { Project } from 'types/project.type'
import { BiAddToQueue, BiUpload } from 'react-icons/bi'
import NewWorkOrder from 'features/work-order/new-work-order'
import { Tabs, TabList, TabPanels, Tab, TabPanel } from 'components/tabs/tabs'
import { WorkOrdersTable } from 'features/work-order/work-orders-table'
import AddNewTransactionModal from 'features/project-details/transactions/add-transaction-modal'
import { VendorDocumentsTable } from 'features/project-details/documents/documents-table'
import { UploadDocumentModal } from 'features/project-details/documents/upload-document'
import { Card } from 'components/card/card'
import ProjectNotes from 'features/project-details/project-notes-tab'
import { STATUS } from 'features/common/status'
import { TransactionDetails } from 'features/project-details/transaction-details/transaction-details'
import { OrderIntakeFormEdit } from './order-intake-form-edit'
import InvoiceModal from './add-invoice-modal'
import { useInvoiceModalClossed } from 'api/invoicing'
// import { InvoiceModal } from 'features/project-details/transactions/New Invoice/Add-Invoice-Modal'

type Props = {
  projectId: any
  projectData?: any
  defaultWorkOrderId?: number | null
}
export const TicketDetails: React.FC<Props> = props => {
  const { t } = useTranslation()
  const { projectId, defaultWorkOrderId } = props

  const { projectData } = usePCProject(projectId)
  const tabsContainerRef = useRef<HTMLDivElement>(null)
  const [tabIndex, setTabIndex] = useState(1)
  const [selectedInvoice, setSelectedInvoice] = useState<any>(null)

  const { mutate: invalidateInvoiceNumber } = useInvoiceModalClossed()

  const {
    isOpen: isOpenTransactionModal,
    onClose: onTransactionModalClose,
    onOpen: onTransactionModalOpen,
  } = useDisclosure()
  const { isOpen: isOpenDocumentModal, onClose: onDocumentModalClose, onOpen: onDocumentModalOpen } = useDisclosure()
  const { isOpen, onOpen, onClose } = useDisclosure()

  const [createdTransID, setCreatedTransID] = useState()

  const setCreatedTransaction = e => {
    setCreatedTransID(e?.data)
  }

  const [isShowProjectFinancialOverview] = useState(false)

  const projectStatus = (projectData?.projectStatus || '').toLowerCase()

  const preventNewTransaction = !!(projectStatus === 'paid' || projectStatus === 'cancelled')
  const location = useLocation()
  const navigate = useNavigate()
  const workOrder = (location?.state as any)?.workOrder || {}
  const transaction = (location?.state as any)?.transaction || {}

  const { isOpen: isOpenInvoiceModal, onClose: onInvoiceModalClose, onOpen: onInvoiceModalOpen } = useDisclosure()

  useEffect(() => {
    if (workOrder?.id) {
      setTabIndex(2)
      navigate(location.pathname, {})
    }
  }, [workOrder])

  useEffect(() => {
    if (transaction?.id) {
      setTabIndex(0)
      navigate(location.pathname, {})
    }
  }, [transaction])

  useEffect(() => {
    if (defaultWorkOrderId) {
      setTabIndex(2)
    }
  }, [defaultWorkOrderId])

  return (
    <>
      <Stack w={{ base: '971px', xl: '100%' }} spacing={'16px'} ref={tabsContainerRef} h="calc(100vh - 1px !important)">
        <Stack w={{ base: '971px', xl: '100%' }} spacing={5} pb="4">
          <Tabs
            index={tabIndex}
            size="sm"
            variant="enclosed"
            colorScheme="brand"
            onChange={index => setTabIndex(index)}
          >
            <TabList ml="11px" h={'50px'} alignItems="end" border="none">
              <Flex h={'40px'} py={'1px'}>
                <Tab>{t('projects.projectDetails.transactions')}</Tab>
                <Tab>Ticket Details</Tab>
                <Tab>{t('projects.projectDetails.vendorWorkOrders')}</Tab>

                <Tab>{t('projects.projectDetails.documents')}</Tab>
                <Tab>{t('projects.projectDetails.notes')}</Tab>
              </Flex>
            </TabList>

            <Card
              ml="11px"
              mr="11px"
              rounded="0px"
              roundedRight={{ base: '0px', md: '6px' }}
              roundedBottom="6px"
              boxShadow={'unset'}
              //pr={{ base: 0, sm: '15px' }}
            >
              <Box w="100%" display="flex" justifyContent={{ base: 'center', sm: 'end' }} position="relative">
                {tabIndex === 2 &&
                  ![
                    STATUS.Closed,
                    STATUS.Invoiced,
                    STATUS.Cancelled,
                    STATUS.Paid,
                    STATUS.Punch,
                    STATUS.ClientPaid,
                    STATUS.Overpayment,
                    STATUS.Reconcile,
                  ].includes(projectStatus as STATUS) && (
                    <Button colorScheme="brand" leftIcon={<BiAddToQueue />} onClick={onOpen} mb="15px" display="none">
                      {t('newWorkOrder')}
                    </Button>
                  )}
                {tabIndex === 3 && (
                  <Button colorScheme="brand" onClick={onDocumentModalOpen} leftIcon={<BiUpload />} mb="15px">
                    {t('projects.projectDetails.upload')}
                  </Button>
                )}
                {tabIndex === 0 && (
                  <HStack spacing="16px" mb="10px">
                    <Button
                      variant="solid"
                      colorScheme="brand"
                      onClick={onTransactionModalOpen}
                      isDisabled={preventNewTransaction}
                      leftIcon={<BiAddToQueue />}
                    >
                      {t('projects.projectDetails.newTransaction')}
                    </Button>
                  </HStack>
                )}
              </Box>
              <TabPanels h="100%">
                <TabPanel p="0px" h="100%">
                  <Box h="100%">
                    {isShowProjectFinancialOverview ? (
                      <TransactionDetails ref={tabsContainerRef} projectId={projectId} />
                    ) : (
                      <TransactionsTable
                        ref={tabsContainerRef}
                        projectStatus={projectData?.projectStatus as string}
                        defaultSelected={transaction}
                        transId={createdTransID}
                        projectId={projectId}
                      />
                    )}
                  </Box>
                </TabPanel>
                <TabPanel p="0px" width="100%">
                  <Box>
                    <OrderIntakeFormEdit projectId={projectId} />
                  </Box>
                </TabPanel>

                <TabPanel p="0px">
                  <WorkOrdersTable
                    ref={tabsContainerRef}
                    defaultSelectedId={defaultWorkOrderId}
                    defaultSelected={workOrder}
                    projectId={projectId}
                  />
                </TabPanel>

                <TabPanel p="0px">
                  <VendorDocumentsTable ref={tabsContainerRef} projectId={projectId} />
                </TabPanel>

                {/* <TabPanel px="0">
              <TriggeredAlertsTable
                onRowClick={(e, row) => {
                  selectedAlertRow(row.values)
                  onAlertModalOpen()
                }}
                ref={tabsContainerRef}
              />
            </TabPanel> */}

                <TabPanel p="0">
                  <ProjectNotes projectId={projectId} />
                </TabPanel>
              </TabPanels>
            </Card>
          </Tabs>
        </Stack>

        <AddNewTransactionModal
          isOpen={isOpenTransactionModal}
          onClose={onTransactionModalClose}
          setCreatedTransaction={setCreatedTransaction}
          projectId={projectId as string}
          projectStatus={projectStatus}
          setShowInvoiceModal={(show: boolean | undefined) => {
            onInvoiceModalOpen()
            onTransactionModalClose()
          }}
        />
        {isOpen && <NewWorkOrder projectData={projectData as Project} isOpen={isOpen} onClose={onClose} />}
        {/* <AlertStatusModal isOpen={isOpenAlertModal} onClose={onAlertModalClose} alert={alertRow} /> */}
        <UploadDocumentModal isOpen={isOpenDocumentModal} onClose={onDocumentModalClose} projectId={projectId} />

        {isOpenInvoiceModal && (
          <InvoiceModal
            isOpen={isOpenInvoiceModal}
            onClose={(invoiceNumber: string | null | undefined, created: boolean) => {
              if (!selectedInvoice && !!invoiceNumber && !created) {
                invalidateInvoiceNumber(invoiceNumber)
              }
              setSelectedInvoice(null)
              onInvoiceModalClose()
            }}
            projectId={projectData?.id}
            selectedInvoice={selectedInvoice}
          />
        )}
      </Stack>
    </>
  )
}
